function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { FileUploader } from 'angular-file-upload';
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos';
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod';
import './editcv-preg.component';
import moment from 'moment';
import { flatMap, groupBy, sortBy, values } from 'lodash';
var EditcvPregComponentCtrl = /*#__PURE__*/function () {
  EditcvPregComponentCtrl.$inject = ["$element", "$timeout", "$log", "FileUploader"];
  function EditcvPregComponentCtrl($element, $timeout, $log, FileUploader) {
    _classCallCheck(this, EditcvPregComponentCtrl);
    // índice dentro de una row
    _defineProperty(this, "rows", []);
    _defineProperty(this, "others", []);
    _defineProperty(this, "respmodel", {
      opt: null,
      opts: null,
      others: null,
      t: null,
      f: null,
      val: null,
      n: null,
      d: null,
      yesno: {
        yes: false,
        no: false,
        details: null
      },
      valid: true
    });
    _defineProperty(this, "uploadReady", false);
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.FileUploader = FileUploader;
  }
  return _createClass(EditcvPregComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this$cvresp$respOrig;
      this.$log.info('[EditcvPregComponentCtrl] onInit');

      // si es de tipo row, una fila por lo menos
      if (this.q.tq == 'ROW' || this.q.tq == 'FILE') {
        this.rows.push('');
      }
      this.cvresp = this.cvmodel.nuevaPreg(this.q, this.superq, this.respmodel, this.idx, this.params);
      this.inline = this.q.tq == 'TEXT' || this.q.tq == 'DATE' || this.q.tq == 'NUMBER' || this.q.tq == 'SELECT' || this.q.tq == 'EMAIL' || this.q.tq == 'YESNO';
      this.mostrar = this.q.tq != 'PARAM' && this.q.tq != 'PARAMOCULTO';

      // si hay respuesta original...
      if ((_this$cvresp$respOrig = this.cvresp.respOriginal) !== null && _this$cvresp$respOrig !== void 0 && _this$cvresp$respOrig.respuestas.length) {
        this._modeloOriginal(this.cvresp.respOriginal.respuestas);
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(object) {
      // actualizar el idx si cambia
      if (object.idx && angular.isDefined(object.idx.currentValue) && object.idx.currentValue != null && this.cvresp) {
        this.$log.debug('Nuevo idx', object.idx);
        this.cvresp.idx = object.idx.currentValue;
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this = this;
      var m = moment('01/01/1940', 'dd/mm/YYYY');
      var max = moment().add(10, 'y');
      this.$timeout(function () {
        ;
        _this.$element.find('select').formSelect();
        _this.$element.find('.datepicker').datepicker({
          autoClose: true
        });
        //
        var instances = M.Datepicker.init(_this.$element.find('.datepicker'), {
          autoClose: true,
          minDate: m.toDate(),
          maxDate: max.toDate(),
          yearRange: [1950, max.year()],
          firstDay: 1
          // container: document.body,
          // onOpen: function () {
          //   angular.element(document.body).addClass('datepicker-open')
          // },
          // onClose: function () {
          //   angular.element(document.body).removeClass('datepicker-open')
          // },
          // onSelect: function () {
          //   angular.element(document.body).removeClass('datepicker-open')
          // },
        });
        if (instances.length) {
          _this._datepicker = instances[0];
          if (_this._date) {
            console.log('----> moment ', moment(_this._date).format('MMM DD, yyyy'));
            _this._datepicker.setDate(moment(_this._date).format('MMM DD, yyyy'));
          }
        }
        console.log('datepicker ==> ', instances, _this.$element.find('.datepicker'));
      }, 500);
      this.$timeout(function () {
        var textarea = _this.$element.find('.materialize-textarea');
        if (textarea && textarea[0]) {
          console.log('------> textareaAutoResize');
          M.textareaAutoResize(textarea);
        }
      }, 10);
      if (this.q.tq == 'FILE') this.$timeout(function () {
        _this.initFileUploads();
      }, 100);
    }
  }, {
    key: "_modeloOriginal",
    value: function _modeloOriginal(rlist) {
      // si es de tipo múltiple, cada respuesta es una opción
      if (this.q.tq === 'MULTIPLE') {
        this._modeloRespMultiple(rlist);
      } else if (this.q.tq === 'ROW') {
        this._modeloRespRow(rlist);
      } else {
        // elegir la primera
        this._modeloRespOriginal(rlist[0]);
      }
    }
  }, {
    key: "_modeloRespOriginal",
    value: function _modeloRespOriginal(r) {
      switch (this.q.tq) {
        case 'TEXT':
        case 'MEMO':
        case 'EMAIL':
        case 'PARAM':
        case 'PARAM2':
        case 'PARAMOCULTO':
          this.respmodel.t = r.resp_txt;
          break;
        case 'DATE':
          if (r.resp_fec) {
            this._date = new Date(r.resp_fec);
            this.respmodel.d = moment(this._date).format('MMM DD, yyyy');
          }
          break;
        case 'NUMBER':
          this.respmodel.n = r.resp_num;
          break;
        case 'SELECT':
          this.respmodel.opt = r.resp_opt;
          break;
        case 'YESNO':
          this.respmodel.yesno.no = !(this.respmodel.yesno.yes = r.resp_bool);
          if (this.respmodel.yesno.yes) {
            this.respmodel.yesno.details = r.resp_yndet;
          }
          break;
        case 'ERROR':
        default:
      }
    }
  }, {
    key: "_modeloRespMultiple",
    value: function _modeloRespMultiple(rr) {
      var _this2 = this;
      // inicializa
      this.respmodel.opts = new Array(this.q.opts.length);

      // opción -> respuesta[]
      var marcadas = groupBy(rr, function (r) {
        return r.resp_opt;
      });

      // cada grupo, ordenado por idx

      // cada respuesta es una opción seleccionada
      // para todas las opciones de la pregunta, marcar si está seleccionada
      this.q.opts.forEach(function (opt, idx) {
        var marcadas_opt = marcadas[opt];
        if (marcadas_opt !== null && marcadas_opt !== void 0 && marcadas_opt.length) {
          var marcada = marcadas_opt.shift();
          _this2.respmodel.opts[idx] = {
            opt: opt,
            obvs: _this2.q.includeDetails ? marcada.resp_obvs : null
          };
        }
      });

      // las que quedan son others
      this.respmodel.others = [];
      var others = flatMap(values(marcadas).filter(function (opts) {
        return opts.length;
      }));
      if (others.length) {
        this.others = new Array(others.length);
      }

      // ordenadas por idx
      sortBy(others, function (r) {
        return r.optidx;
      }).forEach(function (other) {
        _this2.respmodel.others.push({
          opt: other.resp_opt,
          obvs: _this2.q.includeDetails ? other.resp_obvs : null
        });
      });
    }
  }, {
    key: "_modeloRespRow",
    value: function _modeloRespRow(rr) {
      // el nº de respuestas es el nº de filas
      this.rows = new Array(rr.length);
    }
  }, {
    key: "moreinfo",
    value: function moreinfo() {
      this.rows.push('');
    }
  }, {
    key: "addOther",
    value: function addOther() {
      this.others.push('');
    }
  }, {
    key: "yesnochange",
    value: function yesnochange(prop) {
      var val = this.respmodel.yesno[prop];
      if (val) this.respmodel.yesno[prop == 'yes' ? 'no' : 'yes'] = false;
    }
  }, {
    key: "initFileUploads",
    value: function initFileUploads() {
      var uploader = this.uploader = new this.FileUploader({
        // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
        //,timeout: 2000
      });
      this.uploadReady = true;

      // uploader.url = BASE_CANDIDATO_API + "api/_cv/n/abc/f"

      // FILTERS

      // a sync filter
      uploader.filters.push({
        name: 'syncFilter',
        fn: function (item /*{File|FileLikeObject}*/, options) {
          console.log('syncFilter');
          return this.queue.length < 10;
        }
      });

      // an async filter
      uploader.filters.push({
        name: 'asyncFilter',
        fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
          console.log('asyncFilter');
          setTimeout(deferred.resolve, 1e3);
        }
      });

      // CALLBACKS

      uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
        console.info('onWhenAddingFileFailed', item, filter, options);
      };
      uploader.onAfterAddingFile = function (fileItem) {
        if (uploader.queue.length > 1) {
          uploader.removeFromQueue(0);
        }
        console.info('onAfterAddingFile', fileItem);
        console.info('onAfterAddingFile', uploader.queue);
      };
      uploader.onAfterAddingAll = function (addedFileItems) {
        console.info('onAfterAddingAll', addedFileItems);
      };
      uploader.onBeforeUploadItem = function (item) {
        console.info('onBeforeUploadItem', item);
        var f = new FormData();
        f.append('foo', '2');
        item.formData.push(f);
      };
      uploader.onProgressItem = function (fileItem, progress) {
        console.info('onProgressItem', fileItem, progress);
      };
      uploader.onProgressAll = function (progress) {
        console.info('onProgressAll', progress);
      };
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        console.info('onSuccessItem', fileItem, response, status, headers);
      };
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info('onErrorItem', fileItem, response, status, headers);
      };
      uploader.onCancelItem = function (fileItem, response, status, headers) {
        console.info('onCancelItem', fileItem, response, status, headers);
      };
      uploader.onCompleteItem = function (fileItem, response, status, headers) {
        console.info('onCompleteItem', fileItem, response, status, headers);
      };
      uploader.onCompleteAll = function () {
        console.info('onCompleteAll');
      };
      console.info('uploader', uploader);
      this.cvresp.uploaderFiles(uploader);
    }
  }, {
    key: "testUpload",
    value: function testUpload() {
      var _this3 = this;
      var _up = this.uploader;
      this.$log.debug('test uploader', _up.queue);
      _up.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f';
      var idx = 0;
      _up.queue.forEach(function (f) {
        f.onComplete = function (response, status, headers) {
          _this3.$log.debug('Complete!!!!!', status);
        };
        var fd = new FormData();
        fd.append('idx', '' + idx++);
        f.formData = [fd];
        f.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f';
        _up.uploadItem(f);
      });
    }
  }]);
}();
$candidatoPublicMod.component('editcvPreg', {
  bindings: {
    q: '<',
    superq: '<',
    cvmodel: '<',
    params: '<',
    idx: '<',
    principal: '<',
    verestruct: '<',
    verrespuestas: '<'
  },
  controller: EditcvPregComponentCtrl,
  template: require('./editcv-preg.component.html')
  //templateUrl: "./editcv-preg.component.html"
});

// inicializar el fileupload de cabecera